export class SeedReturnItemsFilter {
  itemNo: string;
  clearAll: boolean;
  lotNumber: string;
  invoiceNumber: string;
  productName: string;
  marketingBrand: string;
  packageSize: string;
  treatment: string;
  technology: string;
  seedSize: string;
}
